import React, { useEffect } from "react";
import DataTable from "./DataTable";
import moment from "moment";
import { Icons } from "../constants/icon-library";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { confirmAndDelete } from "./constants";
import { getAllAgents, removeAgent } from "../features/admin/adminSlice";

function Agents() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { agents = [] } = useSelector((state) => state.admin);

  useEffect(() => {
    dispatch(getAllAgents());
  }, [dispatch]);

  const handleRemove = (uuid) => {
    confirmAndDelete({
      uuid,
      dispatch,
      deleteThunk: removeAgent,
      successMessage: "Agent removed successfully.",
      errorMessage: "Failed to remove agent.",
    });
  };

  const columns = [
    { label: "Agent Name", key: "name" },
    { label: "Account Name", key: "accountId.name" },
    { label: "Account Email", key: "userId.email" },
    { label: "Default", key: "isDefault" },
    { label: "Shortcut", key: "shortcut" },
    { label: "Created At", key: "createdAt" },
    { label: "Action", key: "action" },
  ];

  const rowRenderer = (a) => (
    <tr key={a.uuid}>
      <td className="align-middle ps-3">{a.name}</td>

      <td className="align-middle ps-3">
        {a?.accountId?.name || "-"}
      </td>

      <td className="align-middle ps-3">
        {a?.userId?.email || "-"}
      </td>

      <td className="align-middle ps-3">
        {a?.isDefault ? "Yes" : "No"}
      </td>

      <td className="align-middle ps-3">
        {a?.shortcut || "-"}
      </td>

      <td className="align-middle ps-3">
        {moment.utc(a?.createdAt).format("MMM D, YYYY • h:mm A")}
      </td>

      <td className="align-middle text-end">
        <div className="btn-reveal-trigger position-static">
          <button
            className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
            type="button"
            data-bs-toggle="dropdown"
          >
            <i className={`wb ${Icons("dots")} fs-8 me-2 mt-3`} />
          </button>

          <div className="dropdown-menu dropdown-menu-end py-2">
            <button
              className="dropdown-item"
              onClick={() => navigate(`/admin/agents/${a.uuid}`)}
            >
              View Agent
            </button>

            <div className="dropdown-divider"></div>

            <button
              className="dropdown-item text-danger"
              onClick={() => handleRemove(a.uuid)}
            >
              Delete
            </button>
          </div>
        </div>
      </td>
    </tr>
  );

  return (
    <div className="content">
      <div className="row">
        <div className="col-12">
          <DataTable
            title="Agents"
            data={agents}
            columns={columns}
            rowRenderer={rowRenderer}
          />
        </div>
      </div>
    </div>
  );
}

export default Agents;